import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { contactApi } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AdminMessageDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const fetchMessage = async () => {
    try {
      setLoading(true);
      const res = await contactApi.getMessage(id);
      setMessage(res);
    } catch (error) {
      console.error('Failed to load message:', error);
      toast.error('Mesaj yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleToggleRead = async () => {
    if (!message) return;
    setUpdating(true);
    try {
      await contactApi.updateReadState(message._id, !message.read);
      setMessage({ ...message, read: !message.read });
      toast.success('Mesaj durumu güncellendi');
    } catch (error) {
      console.error('Failed to update message:', error);
      toast.error('Mesaj durumu güncellenemedi');
    } finally {
      setUpdating(false);
    }
  };

  if (loading || !message) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => navigate('/admin/messages')}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="font-serif text-2xl font-bold text-foreground">Mesaj Detayı</h1>
            <p className="text-sm text-muted-foreground">
              {message.name} &lt;{message.email}&gt;
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Badge variant={message.read ? 'secondary' : 'default'}>
            {message.read ? 'Okundu' : 'Okunmadı'}
          </Badge>
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={updating}
            onClick={handleToggleRead}
          >
            {message.read ? 'Okunmadı Yap' : 'Okundu İşaretle'}
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="font-serif text-lg">{message.subject || 'Konu Belirtilmemiş'}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-sm text-muted-foreground">
            Gönderim tarihi: {new Date(message.created_at).toLocaleString('tr-TR')}
          </div>
          <div className="prose prose-invert max-w-none whitespace-pre-line text-sm leading-relaxed">
            {message.message}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminMessageDetail;
